export function nextRouterPromiseErrorHandler(e: unknown): void {
    // Workaround for https://github.com/vercel/next.js/issues/37362
    if (!e || typeof e !== 'object' || ('cancelled' in e && e.cancelled)) {
        return
    }

    throw e
}
